/**
 * Send Email - Client-side wrapper
 * 
 * This module delegates ALL email logic to the server endpoint /sendEmailWithLocale
 * which handles: template loading, locale detection, variable replacement, and sending.
 * 
 * This approach avoids bundling server-only modules (sequelize, bcrypt) in the client.
 */

import fetch from '../fetch';

const DEFAULT_LOCALE = 'es';

/**
 * Send email with multi-language support
 * Delegates ALL logic to /sendEmailWithLocale server endpoint
 * 
 * @param {string} to - Recipient email address
 * @param {string} type - Email template type (one of 28 types)
 * @param {object} content - Dynamic content for the template
 * @param {string} locale - User's preferred language (default: 'es')
 * @returns {Promise<{status: number, response: string}>}
 */
export async function sendEmail(to, type, content, locale = DEFAULT_LOCALE) {
    console.log(`[sendEmail] Delegating to server - to: ${to}, type: ${type}, locale: ${locale}`);
    
    try {
        const resp = await fetch('/sendEmailWithLocale', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ 
                to, 
                type, 
                content, 
                locale 
            }),
            credentials: 'include'
        });
        
        const result = await resp.json();
        console.log(`[sendEmail] Server response:`, result);
        return result;
    } catch (error) {
        console.error('[sendEmail] Error:', error);
        return { status: 500, response: error.message };
    }
} 
